<template >
    <Navigation
        class="d-flex"
        :navigationItemList="plotItemList"
        :data="data"
        @selectNavigationItem="selectPlotItem"
        @selectNavigationItemMenu="selectPlotSubItem"
    />
</template>

<script>
    import { EventBus } from '@/event-bus';
    import Navigation from '@/layout/alternative/layout/components/Navigation.vue';

    export default {    
        name: "PlotBody",
        props: [
            "data"
        ],
        components:{
            Navigation,
        },
        computed:{
            plotItemList(){
                return this.data ? this.data.items : {};
            }
        },
        methods: {
            selectPlotItem(item) {
                switch (item.id) {
                    case 'configurable-tour':
                        EventBus.$emit('saveSidebar');
                        this.data.items.filter(el => el.active).forEach(el => { el.active = false });
                        this.$set(item, 'active', true);
                        EventBus.$emit('updateLoadedWidgets', {
                            id: 'configurable-tour',
                            link: item.link,
                            active: true,
                            widgetType: 'configurable-tour'
                        });
                    break;

                    case 'sunshine':
                        this.data.items.filter(el => el.active).forEach(el => { el.active = false });
                        this.$set(item, 'active', true);
                        EventBus.$emit('loadIframeWidget', item.id, item.url);
                    break;

                    case '3d-plan':
                        let activeWidget = this.data.items.filter(el => el.active)[0];
                        if (activeWidget.id === '3d-plan')
                            EventBus.$emit('3d_SetActive', item);
                        else
                            EventBus.$emit('plot_SetActive', item);
                    break;

                    default:
                        EventBus.$emit('plot_SetActive', item);
                    break;
                }
            },
            selectPlotSubItem(item, subitem){
                EventBus.$emit("plot_SetActive", item, subitem);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/layout/alternative/plot/PlotBody.vue